import echart, { EChartOption, EChartsResponsiveOption, ECharts } from 'echarts'
import { getTitleStringByType } from '@/utils/date'

export const drawPieChart = (chart: ECharts, data: any, filter: any) => {
  chart.setOption({
    title: {
      text: `气站消费统计(${getTitleStringByType(filter)})`
    },
    tooltip: {
      trigger: 'item',
      formatter: '{b}: {c}￥ ({d}%)'
    },
    legend: {
      orient: 'vertical',
      right: 5,
      top: 20,
      data: data.map((item: any) => {
        return item.type
      }),
      textStyle: {
        fontWeight: 'normal',
        color: '#fff'
      }
    },
    series: [
      {
        type: 'pie',
        itemStyle: {
          // 通常情况下：
          normal: {
            // 每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
            color: function(params: any) {
              var colorList = [
                '#f67287',
                '#f29e3c',
                '#c05bdd',
                '#7a65f2'
              ]
              return colorList[params.dataIndex]
            }
          },
          // 鼠标悬停时：
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        },
        data: data.map((item: any) => {
          if (item.paytype === 3) {
            return null
          }
          return {
            value: parseFloat(item.total).toFixed(2),
            name: ['余额支付', '微信支付', '卡片支付'][item.paytype]
          }
        })
      }
    ]
  })
}
